import {
  FaHome,
  FaUsers,
  FaTrophy,
  FaCog,
  FaUserFriends,
  FaDollarSign,
  FaMoneyCheckAlt,
  FaMapMarkerAlt,
  FaBook,
  FaCreditCard,
  FaStar,
} from "react-icons/fa";
import {
  FEATURE_AI_LEAGUE_AVERAGE_IMPORT,
  FEATURE_CHECK_PRINTING,
} from "./features";

// Same shape as the tournament bar: four labeled destinations, then Show all.
export const ORGANIZATION_MOBILE_PRIMARY_NAMES = [
  "Dashboard",
  "Members",
  "Tournaments",
  "Bowlers",
];

export const ORGANIZATION_MOBILE_PRIMARY_LIMIT = 4;

export const buildOrganizationNavigation = () => [
  {
    name: "Dashboard",
    href: "/organization",
    icon: FaHome,
    description: "This year's tournaments, entries, and payments",
    isExact: true,
  },
  {
    name: "Members",
    href: "/organization/members",
    icon: FaUsers,
    description: "Manage organization members",
    requiredPermission: "canManageMembers",
  },
  {
    name: "Bowlers",
    href: "/organization/bowlers",
    icon: FaUserFriends,
    description: "Bowler database and management",
    requiredPermission: "canManageOrganizationBowlers",
  },
  {
    name: "Tournaments",
    href: "/organization/tournaments",
    icon: FaTrophy,
    description: "Organization tournament management",
  },
  {
    name: "Bowling centers",
    mobileLabel: "Centers",
    href: "/organization/bowling-centers",
    icon: FaMapMarkerAlt,
    description: "Houses this organization bowls at",
  },
  {
    name: "Average catalogs",
    mobileLabel: "Catalogs",
    href: "/organization/average-catalogs",
    icon: FaBook,
    description: "League sheets and extracted averages",
    requiredPermission: "canManageTournaments",
    requiredFeature: FEATURE_AI_LEAGUE_AVERAGE_IMPORT,
  },
  {
    name: "Payout tables",
    mobileLabel: "Payouts",
    href: "/organization/payout-tables",
    icon: FaDollarSign,
    description: "Prize fund splits for tournaments",
  },
  {
    name: "Check templates",
    mobileLabel: "Checks",
    href: "/organization/check-templates",
    icon: FaMoneyCheckAlt,
    description: "Layouts for printing prize checks",
    requiredPermission: "canManageTournaments",
    requiredFeature: FEATURE_CHECK_PRINTING,
  },
  {
    name: "Plan",
    href: "/organization/plan",
    icon: FaStar,
    description: "AI Assist and Priority for this organization",
    requiredPermission: "canManageOrganization",
  },
  {
    name: "Card payments",
    mobileLabel: "Payments",
    href: "/organization/card-payments",
    icon: FaCreditCard,
    description: "Set up card payments for this organization",
    requiredPermission: "canManageOrganization",
  },
  {
    name: "Profile",
    href: "/organization/profile",
    icon: FaCog,
    description: "Organization profile and public information",
    requiredPermission: "canManageOrganization",
  },
];

export const getOrganizationMobilePrimaryItems = (navigation) => {
  const preferred = ORGANIZATION_MOBILE_PRIMARY_NAMES.map((name) =>
    navigation.find((item) => item.name === name)
  ).filter(Boolean);

  if (preferred.length >= ORGANIZATION_MOBILE_PRIMARY_LIMIT) {
    return preferred.slice(0, ORGANIZATION_MOBILE_PRIMARY_LIMIT);
  }

  const picked = new Set(preferred);
  const extras = navigation.filter((item) => !picked.has(item));
  return [...preferred, ...extras].slice(0, ORGANIZATION_MOBILE_PRIMARY_LIMIT);
};
